module.exports = __webpack_public_path__ + "d50c2bc8.png";